module.exports = __webpack_public_path__ + "img/information-outline.b4acdfd4.svg";